import { ref, watch } from "vue";
import { extractQueryParams } from "@dk.onlinefundraising/onboarding-utils/src/pageHandler";
import requests from "./OfOnboardingRequests";

export const user = ref({})

export const merchant = ref({})
export const merchants = ref({})

let skipWatch = false;

watch(() => merchant.value, () => {
    if (!skipWatch) {
        if (merchant.value) {

            const searchURL = new URL(window.location);

            if (merchant.value.merchantId) {
                searchURL.searchParams.set('merchantId', merchant.value.merchantId)
            } else {
                searchURL.searchParams.delete('merchantId')
            }

            sessionStorage.setItem('merchantId', merchant.value.merchantId);

            window.history.pushState({}, '', searchURL);

        }
    }
    skipWatch = false;
})

window.addEventListener('popstate', async () => {

    skipWatch = true;

    const searchURL = new URL(window.location);

    const merchantId = searchURL.searchParams.get('merchantId')

    if (merchantId) {
        const merchantResult = await requests.getMerchant(merchantId, user.value.agencyId);
        if (merchantResult) {
            merchant.value = merchantResult;
        }

    } else {
        merchant.value = {};
    }

    extractQueryParams();

}) 
